import {Routes} from '@angular/router';
import {P403Component} from "./shared/commons/interceptor/error/403.component";
import {P404Component} from "./shared/commons/interceptor/error/404.component";
import {LayoutComponent} from "./pages/secure/layout/layout.component";
import {AutoLoginPartialRoutesGuard} from "angular-auth-oidc-client";
import {CallbackComponent} from "./security/callback.component";
import {Lk2TokenComponent} from "./pages/secure/lk2-token/lk2-token.component";

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'secure'
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  // {
  //   path: 'home',
  //   component: HomeComponent,
  //   // canActivate: [authenGuard]
  // },
  // {
  //   path: 'portal',
  //   component: PortalComponent,
  // },
  {
    path: 'secure',
    component: LayoutComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'processing'
      },
      {
        path: 'import',
        loadChildren: () => import('./pages/secure/import/import.module').then(m => m.ImportModule),
        data: {title: 'Import'}
      },
      {
        path: 'processing',
        loadChildren: () => import('./pages/secure/processing/processing.module').then(m => m.ProcessingModule),
        data: {title: 'Processing'}
      },
      {
        path: 'lk2-token',
        component: Lk2TokenComponent,
        data: {title: 'LK2 Token'}
      },
    ]
  },
  {
    path: '403',
    component: P403Component,
  },
  {
    path: '**',
    component: P404Component,
  },
];
